import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  item: {
    margin: '0 12px 0 12px',
    display: 'block',
    textTransform: 'uppercase',
  },
  itemTitle: {
    fontSize: fonts.sizes.xxsmall,
    letterSpacing: '1.5px',
    lineHeight: '16px',
    fontWeight: fonts.weights.medium,
    color: colors.gray,
  },
  itemValue: {
    fontSize: fonts.sizes.xxxlarge,
    fontWeight: fonts.weights.normal,
    lineHeight: '36px',
    maxWidth: '15rem',
  },
  tooltipLabel: {
    fontSize: fonts.sizes.medium,
    color: colors.white,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
  },
});

export default useStyles;
